// https://vuex.vuejs.org/en/mutations.html

export default {
  refreshOrders (state, orders) {
    state.list = orders
  },
  updateOrder (state, order) {
    var existingElementIndex
    state.list.some((el, index) => {
      if (el.uid === order.uid) {
        existingElementIndex = index
        return true
      }
    })
    if (existingElementIndex > -1) {
      state.list.splice(existingElementIndex, 1, order)
    } else {
      // Add to the top of the list
      state.list.unshift(order)
    }
  },
  updateBasket (state, basket) {
    state.basket = basket
  },
  loadBasketFromLocalStorage (state) {
    // Check if the ID exists
    if (localStorage.getItem('store-order-basket')) {
      Object.assign(state.basket, JSON.parse(localStorage.getItem('store-order-basket')))
    }
  },
}
